import { useMemo }                         from 'react';
import { generalContent, teacherContent }  from 'utils/constants'
import { appTopicsArrType, pageStateType } from 'types';

const useSetTopics = (
  pageState:    pageStateType,
  appTopicsArr: appTopicsArrType[]
) => {

  const [contentTopics, appTopics] = useMemo(() => {
    return (
      pageState.page === 'content' ?
      [generalContent, appTopicsArr] :
      pageState.page === 'puzzles' ?
      [[], appTopicsArr] :
      pageState.page === 'myContent' ?
      [[],[]] :
      [teacherContent, []]
    )
  },[pageState, appTopicsArr])

  return { contentTopics, appTopics }

}

export default useSetTopics